import './src/scss/theme.scss'
import('../../src/js/app')
const Rellax = require('rellax')
require('owl.carousel')

$(document).ready(function () {
  const rellax = new Rellax('.rellax')
})

$(document).ready(function () {
  $('.suggestion-slider .owl-carousel').owlCarousel({
    margin: 30,
    autoplay: true,
    autoplaySpeed: 1000,
    autoplayTimeout: 10000,
    responsive: {
      0: {
        loop: true,
        nav: true,
        items: 1,
      }
    }
  })

  $('.news-slider .owl-carousel').owlCarousel({
    padding: 0,
    margin: 30,
    autoplay: false,
    items: 1,
    nav: true,
    dots: false,
    navText: [
      '<btn class="btn-sm btn-link"><i class=\'fa fa-fw fa-chevron-left mr-2\'></i></btn>',
      '<btn class="btn-sm btn-link ml-auto"><i class=\'fa fa-fw fa-chevron-right ml-2\'></i></btn>'
    ],
  })
})
